
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-66a8967d&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PromiseToPay.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PromiseToPay.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-66a8967d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PromiseToPay.vue"),
  /* scopeId */
  "data-v-66a8967d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Collection/PromiseToPay.vue
// module id = 666
// module chunks = 0